import Constants from "../config.js";

export async function confirmPopup(message, action_name = "", hard = false) {
	/**
	 * 
	 * @param  {string} message
	 * @param  {string} action_name 		only for hard mode
	 * @param  {bool} 	hard 				adds a checkbox with the action_name
	 */
	const log = (...args) => { console.log("confirmPopup(hard=", hard, "): ", ...args) }

	var popup_confirmed = false
	// if(process.env.NODE_ENV === "production") { // electron app
	if (!Constants.IS_WEB_BUILD) {
		if (hard) {
			var options = {
				type: 'question',
				buttons: ['Yes, continue', 'No, cancel'],
				defaultId: 2,
				title: 'Warning',
				message: message,
				checkboxLabel: 'I confirm I want to ' + action_name,
				checkboxChecked: false,
			};
			await window.electron.openDialogShowMessageBox(options).then(async (resdata) => {
				var response = resdata.response
				const checkboxChecked = resdata.checkboxChecked
				if (response === 0) {
					if (checkboxChecked) {
						popup_confirmed = true
					} else {
						await window.electron.openDialogShowMessageBox({
							title: "Information",
							message: "Vous n'avez pas coché la case de confirmation. La procédure est donc annulée."
						})
						popup_confirmed = false
					}
				}
			});
		} else {
			options = {
				type: 'question',
				buttons: ['Yes, continue', 'No, cancel'],
				defaultId: 2,
				title: 'Warning',
				message: message,
			};
			await window.electron.openDialogShowMessageBox(options).then(async (resdata) => {
				var response = resdata.response
				if (response === 0) {
					popup_confirmed = true
				}
			});
		}
	} else { // web
		return window.confirm(message)
	}
	return popup_confirmed
}

export async function confirmPopupHard(message, action_name) {
	return confirmPopup(message, action_name, true)
}
